// extracted by mini-css-extract-plugin
module.exports = {"reset-password-view":"style_reset-password-view__3Q0NI","margin-bottom10px":"style_margin-bottom10px__6yaZx","margin-top10px":"style_margin-top10px__8_0sv"};